import React from 'react';
import { clsx } from 'clsx';

/**
 * CRITICAL: Loading Spinner Component
 * 
 * This component is used throughout the app for loading states.
 * Changing the structure may break loading UX across the entire app.
 * 
 * Sizes:
 * - sm: 16px (4rem) - for buttons and small elements
 * - md: 24px (6rem) - default size for most use cases
 * - lg: 32px (8rem) - for page-level loading
 * - xl: 48px (12rem) - for full-screen loading
 */

const LoadingSpinner = ({ 
  size = 'md', 
  className = '', 
  color = 'farcaster',
  ...props 
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6', 
    lg: 'w-8 h-8',
    xl: 'w-12 h-12',
  };

  const colorClasses = {
    farcaster: 'border-farcaster-600 border-t-farcaster-200',
    white: 'border-white border-t-gray-300',
    gray: 'border-gray-600 border-t-gray-300',
    primary: 'border-primary-600 border-t-primary-200',
  };

  return (
    <div
      className={clsx(
        'animate-spin rounded-full border-2',
        sizeClasses[size],
        colorClasses[color],
        className
      )}
      role="status"
      aria-label="Loading"
      {...props}
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default LoadingSpinner; 